import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
	selector: 'app-upload-document-modal',
	templateUrl: './upload-document-modal.component.html',
	styleUrls: ['./upload-document-modal.component.scss'],
})
export class UploadDocumentModalComponent implements OnInit {
	inputLabel: string;
	uploadDocumentForm: FormGroup;
	code: any = '';
	fileDetails: any;
	constructor(
		public fb: FormBuilder,
		public dialogRef: MatDialogRef<UploadDocumentModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {
		this.initializeUploadDocumentForm();
		this.inputLabel = this.inputLabel || 'Choose a File';
	}

	initializeUploadDocumentForm() {
		this.uploadDocumentForm = new FormGroup({
			filename: new FormControl('', Validators.compose([Validators.required])),
			// Future feature
			// category: new FormControl('', Validators.compose([Validators.required])),
			description: new FormControl(''),
			fileBody: new FormControl(''),
		});
	}

	save() {
		const result = this.uploadDocumentForm.getRawValue();
		result['file'] = this.fileDetails;
		if (this.uploadDocumentForm.valid) {
			this.dialogRef.close(result);
		}
	}

	close() {
		this.dialogRef.close();
	}

	getFileDetails(event) {
		this.fileDetails = event.target.files[0];
		if (this.fileDetails) {
			this.inputLabel = this.fileDetails.name;
		}
	}

	actionFunction(e) {
		if (e.value === 'submit') {
			this.save();
		} else {
			this.close();
		}
	}
}
